<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-stepper v-model="step" class="password-stepper">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1" color="greenMain">
            Enter Crypro Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2" color="greenMain">
            Verify OTP
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card
              class="deposit-form create-account-form pa-5"
              :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
            >
              <v-row dense>
                <v-col cols="12">
                  <fieldset>
                    <legend>Select Crypto Network</legend>
                    <v-select
                      v-model="formData.network"
                      solo
                      :items="networks"
                      item-text="network"
                      item-value="renamedNetwork"
                      append-icon="mdi-chevron-down"
                      label="Select One"
                      class="custom-select"
                      :error-messages="networkError"
                      @input="validateNetwork"
                    ></v-select>
                  </fieldset>
                </v-col>

                <v-col cols="12">
                  <fieldset class="mt-3">
                    <legend>Enter Your Crypto Address</legend>
                    <v-text-field
                      v-model="formData.address"
                      label="Enter your crypto address"
                      single-line
                      solo
                      :error-messages="addressError"
                      @input="validateAddress"
                      class="custom-select"
                    ></v-text-field>
                  </fieldset>
                </v-col>

                <v-col cols="12">
                  <v-card-actions class="pa-0 mt-3">
                    <v-btn
                      class="ma-0 text-capitalize btn-account"
                      color="greenMain"
                      tile
                      elevation="0"
                      :loading="loading"
                      :disabled="loading || !isValid"
                      @click="sendOtp(2)"
                    >
                      Send OTP
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card
              class="deposit-form create-account-form pa-5"
              :color="$vuetify.theme.dark ? '#172233' : '#ffffff'"
            >
              <v-row>
                <v-col style="position: relative">
                  <v-card-title> Enter OTP </v-card-title>
                  <v-card-text>
                    <p class="bg-timer">
                      Please be advised that you have
                      <span class="text--red">{{ formattedTime }}</span> minutes
                      remaining to authorize your crypto Address add. Thank you
                      for your prompt attention.
                    </p>
                  </v-card-text>
                  <fieldset>
                    <legend>Enter OTP</legend>
                    <v-text-field
                      label="Enter Here"
                      single-line
                      solo
                      hide-details
                      class="custom-select"
                      type="number"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      v-model="inputOtp"
                    ></v-text-field>
                  </fieldset>
                  <v-card-actions class="pa-0">
                    <v-btn
                      v-if="countdownTime <= 0"
                      class="text-capitalize btn-account mr-2"
                      width="256"
                      color="greenMain"
                      tile
                      elevation="0"
                      :loading="loading"
                      :disabled="loading || !this.inputOtp"
                      @click.prevent="resendOTP"
                    >
                      Resend OTP
                    </v-btn>
                    <v-btn
                      v-if="formattedTime !== '0:00'"
                      class="text-capitalize btn-account"
                      width="256"
                      color="greenMain"
                      tile
                      :loading="loading2"
                      :disabled="loading2 || !this.inputOtp"
                      elevation="0"
                      @click.prevent="handleCodeVerify"
                    >
                      Verify & Save
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CRYPTO__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      loading: false,
      loading2: false,
      step: 1,
      countdownTime: null,
      inputOtp: null,

      formData: {
        network: "",
        address: "",
      },

      networkError: "",
      addressError: "",
    };
  },

  computed: {
    ...mapState("crypto", ["networks", "code"]),

    isValid() {
      return (
        this.formData.network &&
        this.formData.address &&
        !this.networkError &&
        !this.addressError
      );
    },

    formattedTime() {
      const minutes = Math.floor(this.countdownTime / 60);
      const seconds = this.countdownTime % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
  },

  methods: {
    ...mapActions("crypto", [
      CRYPTO__ACTIONS.CREATE,
      CRYPTO__ACTIONS.NETWORKS,
      CRYPTO__ACTIONS.SENDOTP,
      CRYPTO__ACTIONS.CODEVERIFY,
    ]),

    async handleCodeVerify() {
      try {
        if (!this.isValid) return;
        this.loading2 = true;
        const verify = await this[CRYPTO__ACTIONS.CODEVERIFY]({
          address: this.formData.address,
          network: this.formData.network,
          code: this.inputOtp,
        });
        if (verify === true) {
          this.$router.push("/bank-information?tab=3");
          this.handleReset();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading2 = false;
      }
    },

    async sendOtp(step) {
      try {
        this.loading = true;
        const otp = await this[CRYPTO__ACTIONS.SENDOTP]();
        if (otp === true) {
          this.step = step;
          this.countdownTime = 120;
          this.startCountdown();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    resendOTP() {
      this.sendOtp(2);
    },

    handleReset() {
      this.countdownTime = null;
      this.formData.address = "";
      this.formData.network = "";
      this.inputOtp = null;
      this.step = 1;
    },

    startCountdown() {
      const timerInterval = setInterval(() => {
        if (this.countdownTime > 0) {
          this.countdownTime -= 1;
        } else {
          clearInterval(timerInterval);
        }
      }, 1000);
    },

    validateNetwork(value) {
      this.networkError = !value ? "Network is required" : "";
    },

    validateAddress(value) {
      const address = (value || "").trim();
      const net = String(this.formData?.network || "").toLowerCase();

      if (!address) {
        this.addressError = "Address is required";
        return false;
      }

      // EVM (ERC20 / BEP20): 0x + 40 hex chars
      const isEvm = /^0x[a-fA-F0-9]{40}$/.test(address);

      // TRON (TRC20): usually starts with T and length ~34 (base58 charset)
      const isTron = /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(address);

      // Optional: TRON hex form (less common in UI): starts with 41 + 40 hex chars
      const isTronHex = /^41[a-fA-F0-9]{40}$/.test(address);

      if (net.includes("bep20") || net.includes("erc20")) {
        if (!isEvm) {
          this.addressError =
            "Invalid address for ERC20/BEP20 (should be 0x + 40 hex)";
          return false;
        }
        this.addressError = "";
        return true;
      }

      if (net.includes("trc20")) {
        if (!(isTron || isTronHex)) {
          this.addressError =
            "Invalid address for TRC20 (should start with T...)";
          return false;
        }
        this.addressError = "";
        return true;
      }

      // If unknown network, you can either allow or block:
      this.addressError = "Unsupported network selected";
      return false;
    },

    async handleSubmit() {
      if (!this.isValid) return;

      this.loading = true;
      try {
        const submitData = {
          ...this.formData,
          crypto_type: this.formData.network, // Add crypto_type if needed
          status: 1, // Default active status
        };
        await this[CRYPTO__ACTIONS.CREATE](submitData);
        this.resetForm();
      } catch (error) {
        console.error("Error saving address:", error);
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.formData = {
        network: "",
        address: "",
      };
      this.networkError = "";
      this.addressError = "";
    },
  },

  async mounted() {
    await this[CRYPTO__ACTIONS.NETWORKS]();
  },
};
</script>

<style scoped>
.text--red {
  color: rgb(255, 73, 73);
}
</style>
